import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

import { GroupsService } from '../../../../api';
import { GroupDto } from '../../types/GroupDto';
import {
  LocalStorageItem,
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../utils';

@Injectable({
  providedIn: 'root',
})
export class CustomGroupService {
  private readonly groupService = inject(GroupsService);

  public async groupListCached(overrideCache = false): Promise<GroupDto[]> {
    const groupListCache = getLocalStorageItem<GroupDto[]>(
      LocalStorageItem.groupList,
    );

    if (groupListCache != null && !overrideCache) {
      return Promise.resolve(groupListCache);
    }

    try {
      const result = await lastValueFrom(this.groupService.groupList());

      setLocalStorageItem(LocalStorageItem.groupList, result);
      return result as GroupDto[];
    } catch (e) {
      console.error(e);
    }

    return [];
  }
}
